<nb-card style="margin:10px;">
  <nb-card-header>
    <div class="title" i18n="@@CreatePlanTemplate">Create Program Template</div>
  </nb-card-header>

  <nb-card-body [formGroup]="planGenerateForm">
    <div class="create_template_item">
      <!-- Name -->
      <ul class="basic_list_informations">
        <li>
          <div i18n="@@Name">
            Name
          </div>
        </li>
        <li>
          <input nbInput style="width:90%" (change)="onTemplateNameChange()" formControlName="templateName"
            [status]="(templateName?.errors?.required ||templateName?.hasError('maxlength')) ? 'danger' : 'primary'"
            type="text" fullWidth shape="semi-round" i18n-placeholder="@@Name" placeholder="Name">
          <ngx-validation-message i18n-label="@@Name" label="Name" [showRequired]="templateName?.errors?.required"
            [showMaxLength]="templateName?.hasError('maxlength')" minLength=5 maxLength=50>
          </ngx-validation-message>
        </li>
      </ul>

      <!-- Description -->
      <ul class="basic_list_informations">
        <li>
          <div i18n="@@Description">
            Description
          </div>
        </li>
        <li>
          <input nbInput style="width:90%" formControlName="templateDescription"
            [status]="(templateName?.hasError('maxlength')) ? 'danger' : 'primary'" type="text" fullWidth
            shape="semi-round" i18n-placeholder="@@Description" placeholder="Description">
          <ngx-validation-message i18n-label="@@Description" label="Description"
            [showMaxLength]="templateDescription?.hasError('maxlength')" maxLength=500>
          </ngx-validation-message>
        </li>
      </ul>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <div>
      <button i18n="@@Create" nbButton type="submit"  (click)="onCreateTemplate()"
        class="btn-circle btn-xl btn-main btn-circle btn-xl" [disabled]="!valid">Create</button>
      <button i18n="@@Cancel" nbButton class="back btn-circle btn-xl" type="submit"  (click)="onCancel()">Cancel</button>
    </div>
  </nb-card-footer>
</nb-card>
